import MemberQuoteCarouselBlock from './MemberQuoteCarouselBlock'

export default MemberQuoteCarouselBlock
